import React from "react";

const PermissionToolbar = ({
    modules,
    searchText,

    setSearchText,

    selectedModule,

    setSelectedModule

}) => {

    return (

        <div className="card shadow-sm mb-3">

            <div className="card-body">

                <div className="row g-3 align-items-end">

                    <div className="col-lg-3">

                        <label className="form-label">

                            Module

                        </label>

                        <select
                            className="form-select"
                            value={selectedModule}
                            onChange={(e) =>
                                setSelectedModule(e.target.value)
                            }
                        >

                            <option value="">

                                All Modules

                            </option>

                            {

                                modules.map(module => (

                                    <option
                                        key={module}
                                        value={module}
                                    >

                                        {module}

                                    </option>

                                ))

    }

</select>

                    </div>

                    <div className="col-lg-5">

                        <label className="form-label">

                            Search Functionality

                        </label>

                        <input
                            className="form-control"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Search Module / Functionality / Code"
                        />

                    </div>

                    <div className="col-lg-2">

                        <button
                            className="btn btn-primary w-100"
                        >

                            Search

                        </button>

                    </div>

                    <div className="col-lg-2">

                        <button
                            className="btn btn-outline-secondary w-100"
                        >

                            Refresh

                        </button>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default PermissionToolbar;